import React, { useEffect, useState } from 'react';
import { PagingQuery } from 'tea-component';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import { useIntl, getLocale } from 'umi';
import {
  ActiveUserMetricColumn,
  avgDAUTitle,
  sumRevenueTitle,
  avgRevenueTitle,
  sumDownloadTitle,
  avgDownloadTitle,
  arpuTitle,
  rankTitle,
  RankColumn,
} from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/ActiveUsersCloums';
import { sortTableByMetric } from '@/pages/intelligence/utils/tableUtils';
import FirstRowEdition from '@/pages/intelligence/components/TableComponents/components/FirstRowEdition';
import { pageAble } from '@/pages/intelligence/utils/commonUtils';
import TopchartTable from '@/pages/intelligence/components/TableComponents/TopchartTable';
import { getActiveuserDetailMetricValueOfCvm } from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/ActiveUserContext/_config/utils';
import { LANGUAGE_CN } from '@/pages/home/_config/config';

const ChannelsCard = (props: any) => {
  const {
    tableData = [],
    unPublishedAppIdList,
    pageId,
    entityType = '',
    gameName,
    gameCover,
    dateType,
    startDate,
    endDate,
    dataSource,
    showRankSwitch,
    fixedTableData,
    onTableSortChage,
    pageSortAttr: defaultPageSortAttr,
  } = props;

  const { formatMessage } = useIntl(); // 中英切换方法
  const locale = getLocale();
  const [sortTableData, setSortTableData] = useState(tableData);
  const [pageSortTable, setPageSortTable] = useState<any[]>([]);
  const [pageSortAttr, setPageSortAttr] = useState(defaultPageSortAttr);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const {
    // tablePageIndex,
    // tablePageSize,
    currentSortValue,
    currentSortMetric,
    currentRatioType,
    // currentOrderSource,
  } = pageSortAttr || {};

  useEffect(() => {
    onSortChage({
      sortMetric: currentSortMetric,
      sortVal: currentSortValue,
      ratioType: currentRatioType,
    });
  }, [tableData]);

  const handleSortChange = (e: SortByItemType) => {
    onTableSortChage?.(e);
    onSortChage(e);
  };

  const onSortChage = (e: SortByItemType) => {
    setPageSortAttr({
      currentSortValue: e.sortVal,
      currentSortMetric: e.sortMetric,
      currentRatioType: e.ratioType,
    });

    const sortTable = sortTableByMetric({
      tableData,
      sortParams: e,
      timeProperty: 'time',
      metricProperty: 'metric',
      growthProperty: 'growth_ratio',
    });
    const pageList: any[] = pageAble(sortTable, pageIndex, pageSize);
    setPageSortTable([...(fixedTableData || []), ...(pageList || [])]);
    setSortTableData(sortTable.slice(0));
  };

  const onPagingChange = (e: PagingQuery) => {
    setPageIndex(e.pageIndex || 1);
    setPageSize(e.pageSize || 5);
    // onTablePagingChange(e);
    const pageList = pageAble(sortTableData, e.pageIndex, e.pageSize);
    setPageSortTable([...(fixedTableData || []), ...(pageList || [])]);
  };

  const getMetricValueWithCompare = (cvm: any, sortMetric: string) => {
    return getActiveuserDetailMetricValueOfCvm(cvm, sortMetric, {
      entityType,
      gameName,
      gameCover,
      dateType,
      startDate,
      endDate,
    });
  };

  const getMetricCloums = (dataSource: string) => {
    const metricCloums: any[] = [];
    // DAU Revenue Download 每个数据源赋值一遍
    const titles = [];
    if (pageId === 'activeusers') {
      titles.push(
        avgDAUTitle({
          dataSource,
          tab: 'editions',
          dateType,
          title: 'Activeusers',
        }),
      );
    } else if (pageId === 'revenue') {
      titles.push(
        sumRevenueTitle({
          dataSource,
          tab: 'editions',
          dateType,
          title: 'Revenue',
        }),
        avgRevenueTitle({
          dataSource,
          tab: 'editions',
          dateType,
          title: 'Revenue',
        }),
        arpuTitle,
      );
    } else if (pageId === 'downloads') {
      titles.push(
        sumDownloadTitle({
          dataSource,
          tab: 'editions',
          dateType,
          title: 'Downloads',
        }),
        avgDownloadTitle({
          dataSource,
          tab: 'editions',
          dateType,
          title: 'Downloads',
        }),
      );
    }
    if (showRankSwitch) {
      titles.push(rankTitle);
    }
    titles.forEach((t) => {
      if (t.key === 'rank') {
        metricCloums.push(
          RankColumn({
            title: t.title,
            key: t.key,
            currentSortValue,
            currentSortKey: currentSortMetric,
            onSortChage: handleSortChange,
            width: t.width,
            isRank: true,
          }),
        );
      } else {
        metricCloums.push(
          ActiveUserMetricColumn({
            dataSource, // source === 'ogdb' ? 'databarin' : source,
            title: locale === LANGUAGE_CN ? t?.title_cn || t?.title : t?.title,
            textContent: t.textContent,
            key: `${t.key}_${dataSource}`,
            sortMetric: t.key,
            metricKey: t?.metricKey || t.key,
            entityType,
            currentSortValue,
            currentSortKey: `${currentSortMetric}_${dataSource}_${currentRatioType}`,
            onSortChage: handleSortChange,
            tipText: t.tipText,
            width: t.width,
            width_cn: t?.width_cn,
            getMetricValueOfCvm: getMetricValueWithCompare,
          }),
        );
      }
    });
    return metricCloums;
  };

  return (
    <>
      <TopchartTable
        loading={false}
        records={pageSortTable}
        tableTotal={sortTableData?.length}
        pageIndex={pageIndex}
        pageSize={pageSize}
        onPagingChange={onPagingChange}
        pageSizeOptions={[5, 10, 15]}
        className="dbi-mobileGames-details-table"
        columns={[
          {
            key: 'app_id',
            header: (
              <div className="stats-table-title">
                <span className="stats-table-title-text">
                  {formatMessage({ id: 'dbi_top_editions' })}
                </span>
                <span className="stats-table-title-subtext">
                  ({sortTableData?.length || 0})
                </span>
              </div>
            ),
            width: 300,
            align: 'left',
            render: (cvm: any) => {
              const isUnPublished = unPublishedAppIdList?.includes(cvm?.app_id);
              if (cvm?.app_id === 'total') {
                return <>Total</>;
              }
              return (
                <FirstRowEdition
                  name={cvm?.name}
                  isUnPublished={isUnPublished}
                  platform={cvm?.platform}
                  imgSrc={cvm?.cover}
                />
              );
            },
          },
          ...getMetricCloums(dataSource),
        ]}
      />
    </>
  );
};

export default ChannelsCard;
